var CHAT_NOTIFIER_LOAD_SUCCESS = 'CHAT_NOTIFIER_LOAD_SUCCESS';
var CHAT_NOTIFIER_LOAD_URL = '/messenger-api/notification/index';
var REDUCER_CHAT_NOTIFIER_NAME = 'reducerChatNotifier';
export { CHAT_NOTIFIER_LOAD_SUCCESS, CHAT_NOTIFIER_LOAD_URL, REDUCER_CHAT_NOTIFIER_NAME };